import { useEffect, useState } from 'react'
import { IFaqArticle } from '../../faq.types'
import faqApi from '../../faq.api'
import useDebounce from '../../../../../shared/hooks/useDebounce'
import useHttpLoader from '../../../../../shared/hooks/useHttpLoader'

const useFaqArticleSearch = () => {
  const { loading, wait } = useHttpLoader()
  const [selectedArticleId, setSelectedArticleId] = useState<IFaqArticle['id'] | null>(null)
  const [search, setSearch] = useState('')
  const [articles, setArticles] = useState<IFaqArticle[]>([])
  const debouncedSearch = useDebounce(search, 400)

  useEffect(() => {
    if (!debouncedSearch) {
      setArticles([])
      return
    }

    wait(faqApi.searchArticles(debouncedSearch), (resp) => {
      if (resp.status === 'success') {
        setArticles(resp.body)
      }
    })
  }, [debouncedSearch])

  return {
    loading,
    search,
    articles,
    selectedArticleId,
    setSelectedArticleId,
    setSearch,
  }
}

export default useFaqArticleSearch
